module.exports = __webpack_public_path__ + "static/media/profile-professionnel.cd014578.svg";